import React, {createContext, useContext, useState} from 'react';

import {Query} from '../../state/runs/types';
import {Zoom} from '../PanelRunsLinePlot/types';

export interface SharedPanelQueryState {
  query: Query | null;
  result: any;
}

interface SharedPanelStateContextType {
  queryState: SharedPanelQueryState;
  setQueryState: (queryState: SharedPanelQueryState) => void;
  userZoomState: Zoom;
  setUserZoomState: React.Dispatch<React.SetStateAction<Zoom>>;
}

export const SharedPanelStateContext =
  createContext<SharedPanelStateContextType>({
    queryState: {
      query: null,
      result: null,
    },
    setQueryState: () => {},
    userZoomState: {},
    setUserZoomState: () => {},
  });

export const SharedPanelStateContextProvider: React.FC = ({children}) => {
  const [queryState, setQueryState] = useState<SharedPanelQueryState>({
    query: null,
    result: null,
  });
  const [userZoomState, setUserZoomState] = useState<Zoom>({});
  return (
    <SharedPanelStateContext.Provider
      value={{
        queryState,
        setQueryState,
        userZoomState,
        setUserZoomState,
      }}>
      {children}
    </SharedPanelStateContext.Provider>
  );
};

export const useSharedPanelState = (): SharedPanelStateContextType => {
  return useContext(SharedPanelStateContext);
};
